import React, { useEffect, useState } from "react";
import { useUnlink } from "../context/UnlinkContext";
import { encryptData } from "../utils/CryptoHelpers";
import { storeUnlinkKeys } from "../db/KeyStorageManager";
import { usePasswordAndUserId } from "../context/AuthContext";
import bs58 from 'bs58';

export default function SetupUnlinkSecretView({ onImport, onBack, navigate }) {
  const sdk = useUnlink();
  const { password, userId, salt } = usePasswordAndUserId();
  const [mnemonic, setMnemonic] = useState("");
  const [viewPublicKey, setViewPublicKey] = useState("");
  const [keys, setKeys] = useState(null);
  
  useEffect(() => {
    const generate = async () => {
      const keypairs = await sdk.generateUnlinkKeypair();
      setMnemonic(keypairs.mnemonic);
      setViewPublicKey(bs58.encode(keypairs.viewPublicKey));
      setKeys(keypairs); // save full object
    };
    generate();
  }, [sdk]);

  const handleConfirmSaved = async () => {
    
    if (!keys || !password || !salt || !userId) return;

    await storeUnlinkKeys(userId, password, salt, keys, mnemonic);

    navigate("contacts");
  };

  return (
    <div style={{ height: "100vh", width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: "#000", color: "#fff", overflow: "hidden", padding: "2rem", boxSizing: "border-box" }}>
      <img src="/images/welcome-icon.png" alt="Welcome Icon" style={{ width: "120px", height: "auto", marginBottom: "0.5rem", marginTop: "1rem" }} />

      <h2 style={{ marginBottom: "0.5rem", fontSize: "1.5rem" }}>Welcome to Unlink!</h2>
      <p style={{ color: "#aaa", marginBottom: "2rem", fontSize: "0.95rem", textAlign: "center" }}>
        You’re almost ready. Let’s set up your secure, private identity.
      </p>

      {/* Unlink Address */}
      <div style={{ width: "100%", maxWidth: "400px", backgroundColor: "#111", padding: "1rem", borderRadius: "6px", border: "1px solid #333", marginBottom: "1.5rem" }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
          <strong style={{ fontSize: "0.95rem", color: "#ccc" }}>Your Unlink Address</strong>
          <img src="/images/shield-icon.png" alt="Shield" style={{ width: "18px", height: "18px", marginLeft: "0.5rem" }} />
        </div>
        <div style={{ fontFamily: "monospace", fontSize: "0.85rem", wordBreak: "break-word", color: "#4e8cff", marginBottom: "0.5rem" }}>
          {viewPublicKey}
        </div>
        <p style={{ color: "#666", fontSize: "0.8rem", margin: 0 }}>
          Others can message you using this address — but your identity stays private.
        </p>
      </div>

      {/* Recovery Phrase */}
      <div style={{ width: "100%", maxWidth: "400px", backgroundColor: "#111", padding: "1rem", borderRadius: "6px", border: "1px solid #333", marginBottom: "2rem" }}>
        <div style={{ marginBottom: "0.5rem" }}>
          <strong style={{ fontSize: "0.95rem", color: "#ccc" }}>Secret Recovery Phrase</strong>
        </div>
        <div style={{ fontFamily: "monospace", fontSize: "0.95rem", wordBreak: "break-word", color: "#4e8cff", marginBottom: "0.5rem" }}>
          {mnemonic}
        </div>
        <p style={{ color: "#666", fontSize: "0.8rem", margin: 0 }}>
          This is your backup. It restores your Unlink identity and contacts. Store it safely — we won’t show it again.
        </p>
      </div>

      {/* CTAs */}
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
        <button onClick={handleConfirmSaved} style={{ padding: "0.75rem 1.25rem", fontSize: "1rem", borderRadius: "6px", border: "none", backgroundColor: "#4e8cff", color: "#fff", cursor: "pointer", minWidth: "160px" }}>
          I’ve saved my secret
        </button>
        <button onClick={onImport} style={{ padding: "0.75rem 1.25rem", fontSize: "1rem", borderRadius: "6px", border: "1px solid #4e8cff", backgroundColor: "transparent", color: "#4e8cff", cursor: "pointer", minWidth: "160px" }}>
          Import existing
        </button>
      </div>
    </div>
  );
}